import { forEach } from "lodash";

export const createUrlForNewRequestToField = ( urlAsString, toAsString ) =>
{
    return urlAsString + "?to=" + encodeURIComponent( toAsString );
};

export const getNewRequestToFieldFromUrl = ( location, state ) =>
{
    let match;
    let to = null; // default value

    if( location )
    {
        if( location.search )
        {
            match = location.search.match(/to=([^&]+)/i);
            if( match )
            {
                to = match[1];
            }
        }
    }

    let exists = false;
    let { resource: { users }} = state;
    if( users )
    {
        forEach( users.item, user => {
            {
                if( user.identifier === to )
                {
                    exists = true;
                }
            }
        });
    }

    // console.log( 'BBB', {location,match,to,exists,users,state});

    if( ! exists )
    {
        return null;
    }
    else
    {

        return to;
    }
};


// WEBPACK FOOTER //
// ./src/Atollon/Request_PreselectFieldsInRequest.js